import React from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Input, Button, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const EditDiscountCodeModal = ({ isOpen, toggle, onSave, discountCode, onInputChange }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Edit Discount Code</ModalHeader>
            <ModalBody>
                <Form onSubmit={(e) => { e.preventDefault(); onSave(discountCode); }}>
                    <FormGroup>
                        <Label for="code">Code</Label>
                        <Input
                            type="text"
                            id="code"
                            name="code"
                            value={discountCode.code}
                            onChange={(e) => onInputChange('code', e.target.value)}
                            required
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label for="discountAmount">Discount Amount</Label>
                        <Input
                            id="discountAmount"
                            name="discount_amount"
                            type="text"
                            value={discountCode.discount_amount}
                            onChange={(e) => onInputChange('discount_code', e.target.value)}
                            required
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label for="expires_at">Expires</Label>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <DatePicker 
                                id="expiresAt"
                                name="expiresAt"
                                className="form-control"
                                selected={discountCode.expires_at ? moment(discountCode.expires_at).toDate() : null}
                                onChange={(date) => onInputChange('expires_at', date)}
                                showTimeSelect
                                timeIntervals={15}
                                dateFormat="MM/dd/yyyy h:mm aa"
                                style={{ marginLeft: '10px' }} 
                            />
                        </div>
                    </FormGroup>

                    <FormGroup>
                        <Label for="description">Description</Label>
                        <Input
                            type="text"
                            name="description"
                            id="description"
                            value={discountCode.description}
                            onChange={(e) => onInputChange('description', e.target.value)}
                        />
                    </FormGroup>

                    <Button color="primary" type="submit">Save</Button>{' '}
                    <Button color="secondary" onClick={toggle}>Cancel</Button>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default EditDiscountCodeModal;
